import FieldMixin from 'trunks/vue/share/components/fields/field.js';
import { LogicalFieldMixin } from 'trunks/vue/share/mixins/logic_field/index.js';
import Field from './field.js';

const FieldMixinForResponse = {
  mixins: [
    FieldMixin,
    LogicalFieldMixin
  ],

  components: {
    Field: Field
  },

  props: {
    editing: {
      type: Boolean
    }
  },

  computed: {
    fieldDifferenceClass: function() {},

    fieldCommonClass: function() {
      return {
        'has-error': !this.valid,
        required: this.field.validations.indexOf('presence') > -1,
        disabled: this.field.visibility === 'protected_visibility' && !this.isAdmin,
        'inline': this.field.settings.layout === 'inline'
      };
    }
  },

  watch: {
    entries: function() {
      if (!this.editing) {
        this._parseEntriesToValue(this._initDefaultEntries(this.entries));
      }
    }
  }
};

export default FieldMixinForResponse;
